export default "__VITE_ASSET__Dt5h5I15__"